import * as moment from 'moment';
import { stateConvert } from 'web/components/utils/stateAbbreviation';

export const globalTermsListTableHeader = [
  { title: 'Date/time stamp' },
  { title: 'PT.com Seller Fee' },
  { title: 'PT.com Buyer Fee' },
  { title: 'PT.com Broker Fee' },
  { title: 'PT+ Managed Del' },
  { title: 'PT+ Managed PU' },
  { title: 'Supplier Del Terms' },
  { title: 'Supplier PU Terms' },
  { title: 'Comments', },
];

export const globalTermsHighlight = [
  { title: 'PT.com Seller Fee' },
  { title: 'PT.com Buyer Fee' },
  { title: 'PT.com Broker Fee' },
  { title: 'PT+ Managed Del' },
  { title: 'PT+ Managed PU' },
  { title: 'Supplier Del Terms' },
  { title: 'Supplier PU Terms' },
];

export const supplierTermsListTableHeader = [
  { title: 'Company Name – Address, City ST', },
  { title: 'Payment Terms', },
  { title: 'Payment Discount %', },
  { title: 'Collection Terms', },
  { title: 'Collection Discount %', },
  { title: 'PT.com Seller Fee', id: 'sellerFee', infotText: 'The Seller Fee applies to PT.com Marketplace. For PT+ Managed Business, the Seller Fee will be taken from the Global Terms.' },
  { title: 'PT.com Buyer Fee', id: 'buyerFee', infotText: 'The Buyer Fee applies to PT.com Marketplace. For PT+ Managed Business, the Buyer Fee will be taken from the Global Terms.' },
  { title: 'PT.com Broker Fee', id: 'brokerFee', infotText: 'The Broker Fee applies to PT.com Marketplace. For PT+ Managed Business, the Broker Fee will be taken from the Global Terms.' },
  { title: 'Date/time', },
  { title: 'Comments', },
  { title: 'Action', },
];

// to avoid the values with commas from splitting to adjacent cells while viewing in excel
const wrapInQuotes = (value) => {
  if (value === null || value === undefined || value === "") return '"NA"';
  return `"${value.toString().replace(/"/g, '""')}"`; // Escape double quotes
};

export const rawSupplierTermsCsvColumns = [
  { id: 'companyName', displayName: 'Company Name – Address, City ST' },
  { id: 'paymentTerms', displayName: 'Payment Terms' },
  { id: 'deliveryTermDiscount', displayName: 'Payment Terms Discount %' },
  { id: 'collectionTerms', displayName: 'Collection Terms' },
  { id: 'pickupTermDiscount', displayName: 'Collection Terms Discount %' },
  { id: 'ptSellerFee', displayName: 'PT.com Seller Fee' },
  { id: 'ptBuyerFee', displayName: 'PT.com Buyer Fee' },
  { id: 'ptBrokerFee', displayName: 'PT.com Broker Fee' },
  { id: 'timeStamp', displayName: 'Date/time' },
  { id: 'comments', displayName: 'Comments' },
]

// Map and wrap column header
export const supplierTermsCsvColumns = rawSupplierTermsCsvColumns.map(col => ({
  ...col,
  displayName: wrapInQuotes(col.displayName),
}));

export const formCsvData = (list) => {
  let csvData = list?.map(data => {
    let obj = {
      companyName: `${data.companyDetails?.companyName} - ${data.companyDetails?.address}, ${data.companyDetails?.city} ${stateConvert(data.companyDetails?.state) || data.companyDetails?.state}`,
      paymentTerms: data?.paymentTerms ? `${data?.paymentTerms} days` : 'NA',
      deliveryTermDiscount: data?.deliveryTermDiscount !== null ? `${data?.deliveryTermDiscount} %` : 'NA',
      collectionTerms: data?.collectionTerms ? `${data?.collectionTerms} days` : 'NA',
      pickupTermDiscount: data?.pickupTermDiscount !== null ? `${data?.pickupTermDiscount} %` : 'NA',
      ptSellerFee: data?.sellerFee !== null ? `${data?.sellerFee} %` : 'NA',
      ptBuyerFee: data?.buyerFee !== null ? `${data?.buyerFee} %` : 'NA',
      ptBrokerFee: data?.brokerFee !== null ? `${data?.brokerFee} %` : 'NA',
      timeStamp: moment(data.feeDateTime).format('MM/DD/YYYY, hh:mm A'),
      comments: data?.comments
    }
    return Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, wrapInQuotes(value)]));
  });
  return csvData
}